import { createStyles, Grid, makeStyles, Theme } from "@material-ui/core";
import React from "react";
import { connect } from "react-redux";
import { APIConstants } from "../../utils/api/constants";
import { APIState } from "../../utils/api/reducer";
import { setScoring } from "../store/actions";
import { ScoringOption } from "../store/types";
import ScoringInput from "./ScoringInput";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      justifyContent: "center",
      alignItems: "center",
    },
  })
);

interface ReduxProps {
  readonly scoringOptions: APIState<ScoringOption[]>;
}

interface DispatchProps {
  readonly SetScoring: (scoring: string) => void;
}

type Props = ReduxProps & DispatchProps;

const ScoringInputs = (props: Props) => {
  const { scoringOptions, SetScoring } = props;
  const classes = useStyles();
  return (
    <Grid container className={classes.root}>
      {scoringOptions.status === APIConstants.SUCCEEDED && (
        <Grid item xs={12} sm={6} lg={3}>
          <ScoringInput
            options={scoringOptions.data}
            setScoring={(scoring: string) => SetScoring(scoring)}
          />
        </Grid>
      )}
    </Grid>
  );
};

const mapStateToProps = (state: any) => {
  const { scoringOptions } = state.startSit;
  return {
    scoringOptions,
  };
};

const mapDispatchToProps = {
  SetScoring: setScoring,
};

export default connect(mapStateToProps, mapDispatchToProps)(ScoringInputs);
